var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 39C1.25 35.9624 3.71243 33.5 6.75 33.5C9.78757 33.5 12.25 35.9624 12.25 39V48.5H2.75C1.92157 48.5 1.25 47.8284 1.25 47V39Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 39C12.25 35.9624 14.7124 33.5 17.75 33.5C20.7876 33.5 23.25 35.9624 23.25 39V48.5H12.25V39Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 39C23.25 35.9624 25.7124 33.5 28.75 33.5C31.7876 33.5 34.25 35.9624 34.25 39V48.5H23.25V39Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 39C34.25 35.9624 36.7124 33.5 39.75 33.5C42.7876 33.5 45.25 35.9624 45.25 39V47C45.25 47.8284 44.5784 48.5 43.75 48.5H34.25V39Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 11.2679C32.0833 12.0377 32.0833 13.9623 30.75 14.7321L21.75 19.9282C20.4167 20.698 18.75 19.7358 18.75 18.1962L18.75 7.80385C18.75 6.26425 20.4167 5.302 21.75 6.0718L30.75 11.2679Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 21C7.45 14.6 8.58333 4.66667 8.75 0.5H2.25V26H8.25C8.25 23.6 5.58333 21.6667 4.25 21Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25 21C40.05 14.6 38.9167 4.66667 38.75 0.5H45.25V26H39.25C39.25 23.6 41.9167 21.6667 43.25 21Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.5H39.25",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 26H39.25",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 49,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/Cinema.285f01cf7b11dc201f32726b2212fa35.svg";
export { ForwardRef as ReactComponent };